<template>
  <two-sides-modal
    v-model="isDialogOpen"
    :title="bonusName"
    subtitle="Bonos"
    icon="mdi-cash-register"
    height="auto"
    persistent
  >
    <p class="mb-0 mt-5">Se descontará de su {{ bonusName }}</p>
    <v-data-table
      dense
      :headers="headers"
      :items="selectedInvoice"
      class="elevation-1 table-renglonaje tabla-zebra mt-5"
      no-data-text="No se encontro información"
      disable-pagination
      hide-default-footer
    >
      <template #[`item.amount`]="{ item }">
        {{ formatNumber(item.amount) }}
      </template>
    </v-data-table>
    <v-row class="mt-5 text-left">
      <v-col md="6">
        <p class="font-weight-bold mb-0 align-left">
          Bono Disponible: ${{ bondCost | formatCurrency }}
        </p>
        <p v-if="validateDiscount" class="font-weight-bold mb-0">
          Monto DPP: ${{ selectedInvoice[0].difbudatnet | formatCurrency }}
        </p>
      </v-col>
      <v-col v-if="type == '2RC'" md="6">
        <v-text-field
          v-model="formattedCost"
          class="mt-2"
          outlined
          dense
          label="Ingrese el monto"
          prepend-icon="mdi-credit-card"
          :error-messages="errorMessage"
          @keypress="isNumber($event)"
        />
      </v-col>
    </v-row>
    <template slot="actions-append">
      <v-btn
        class="green-button"
        :disabled="loading"
        :loading="loading"
        @click="onApply"
      >
        Aplicar
      </v-btn>
    </template>
  </two-sides-modal>
</template>
<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import numbersFormats from '@/mixins/numbersFormats';
  import TwoSidesModal from '@/components/modals/TwoSidesModal.vue';

  export default {
    name: 'BonusModal',
    components: { TwoSidesModal },
    mixins: [numbersFormats],
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      selectedInvoice: {
        required: true,
      },
      type: {
        type: String,
      },
      bonds: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
      },
    },
    data() {
      return {
        headers: [
          { text: 'Factura', value: 'number' },
          { text: 'Monto', value: 'amount' },
        ],
      };
    },
    computed: {
      bonusName() {
        return this.type == '2RC' ? 'Bono Rebate' : 'Bono POP';
      },
      formattedCost: {
        get() {
          return this.bondCost;
        },
        set(value) {
          this.validateBondAmount(value);
          this.$emit('amount', value);
        },
      },
      bondCost: function () {
        const bonusCost = this.bonds?.find((b) => b.id == this.type)?.cost;
        if (bonusCost !== undefined) return this.unformatNumber(bonusCost);
        return '';
      },
      validateDiscount() {
        const totalAmount = parseFloat(this.selectedInvoice[0]?.amount).toFixed(
          2
        );

        return this.bondCost > 0 &&
          this.bondCost >= totalAmount &&
          this.type == '2RC'
          ? true
          : false;
      },
      isMobile() {
        return (
          this.$vuetify.breakpoint.name === 'sm' ||
          this.$vuetify.breakpoint.name === 'xs'
        );
      },
      isDialogOpen: {
        set(newVal) {
          this.$emit('input', newVal);
        },
        get() {
          return this.value;
        },
      },
    },
    methods: {
      closeModal() {
        this.$emit('onClose');
      },
      onApply() {
        this.$emit('applyBond');
      },
      validateBondAmount(value) {
        if (value > this.bondCost) {
          this.errorMessage = `El monto no puede ser mayor a $${this.$options.filters.formatCurrency(
            this.bondCost
          )}`;
          this.$emit('disabled', true);
        } else {
          this.errorMessage = '';
          this.$emit('disabled', false);
        }
      },
    },
  };
</script>
<style scoped src="../../../assets/css/accountmove.css"></style>
